import { Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import get from 'lodash-es/get';

import { Location } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '@finder/features/calendars/services/calendars.service';
import { SectionComponent } from '@finder/shared/components/section/section.component';
import { ParkRowComponent } from '../park-row/park-row.component';
import { LoadingSpinnerComponent } from '@finder/shared/components/loading-spinner/loading-spinner.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'finder-park-table',
    templateUrl: './park-table.component.html',
    styleUrls: ['./park-table.component.scss'],
    standalone: true,
    imports: [
        SectionComponent,
        ParkRowComponent,
        LoadingSpinnerComponent,
        CommonModule,
    ]
})
export class ParkTableComponent implements OnInit {

    @Input() location: Location;
    @Input() labels: any;
    @Input() icons: any;

    loading = false;
    icon: string;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarsService: CalendarsService,
    ) { }

    ngOnInit() {
        this.icon = get(this.icons, this.location.urlFriendlyId);
        this.calendarsService.getLoadingState()
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.loading = state);
    }

}
